import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaList, FaCog, FaPencilAlt, FaClone, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';

import ReportAPI from '../../api/ReportAPI';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import ApiUiController from '../../controller/ApiUiController';
import FieldController from '../../controller/FieldController';

class ReportList2 extends React.Component {
  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.state = { inApiCall: true, active: 'Fixed Reports', popup: false, id: 0, roles: [], users: [], report: [] };
    this.path = this.props.match.path;
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    const model = this.models.report;
    this.reports = model;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Edit = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
    this.Permission = Util.isAllow(model.permission, Const.PermAllowPermission);
    this.report = ["Fixed Reports", "Dynamic Reports"];
    this.fixedReports = Const.FixedreportsList;
    this.Roles = FieldController.getOptions({ field_type: 'select~role' });
  }

  componentDidMount() {
    if (this.List) {
      ReportAPI.list(this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = reports => { this.setState({ report: reports }); };

  onTabClick = active => this.setState({ ...this.state, active });

  onPermit = report => {
    const state = { ...this.state };
    state.id = report.id;
    state.roles = [];
    state.users = [];
    if (report.roles) {
      state.roles = this.Roles.filter(role => report.roles.includes(`${Const.Opt}${role.value}${Const.Opt}`));
    }
    if (report.users) {
      state.users = this.Users.filter(user => report.users.includes(`${Const.Opt}${user.value}${Const.Opt}`));
    }

    this.setState({ ...this.state, ...state, popup: true });
  };
  onSubmit = () => {
    const report = {
      id: this.state.id,
      roles: `${Const.Opt}${this.state.roles.map(role => role.value).join(Const.Opt)}${Const.Opt}`,
      users: `${Const.Opt}${this.state.users.map(user => user.value).join(Const.Opt)}${Const.Opt}`
    };
    ReportAPI.updatePermssion(report, () => ReportAPI.list(this.onReceived, this.onFail), this.onFail);

    this.setState({ ...this.state, inApiCall: true, popup: false });
  };

  onCopy = id => {
    ReportAPI.copy(id, this.onCopySuccess, this.onFail);
    this.setState({ ...this.state, inApiCall: true, popup: false });
  };

  onEdit = report => {
    if (report.model && report.sub_model) {
      this.props.navigate(`${this.path}/add-edit/${report.id}`);
    } else if (report.model && !report.sub_model) {
      this.props.navigate(`${this.path}/add-edit/${report.id}`);
    }
  };

  onCopySuccess = () => {
    Util.showNotification('Successful', 'Copy successfully', 'success');
    ReportAPI.list(this.onReceived, this.onFail);
  };

  confirmDelete = report => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${report.name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ReportAPI.delete(report.id, this.onDelete, this.onFail);
      });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Report Deleted successfully', 'success');
    ReportAPI.list(this.onReceived, this.onFail);
  };

  onCancel = () => this.setState({ ...this.state, popup: false });

  render() {
    if (!this.List) return null;
    return (
      <div className='sectionlist pt-3'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-6 pb-3'>
              <h3>Reports</h3>
            </div>
            <div className="col-md-6 text-right pb-3">
              {/* <a href="https://docs.google.com/spreadsheets/d/1Yk65hrVEcPQDz0dwR77hFQLB2XmoHZ6OjQcOr1xQjGg/edit?usp=sharing"
                className="buttons call"
                target="_blank" rel="noreferrer">
                Report List
              </a> */}
              {this.Add
                ? <NavLink to={`${this.path}/add-edit/0`} className="buttons success">
                  Create Report
                </NavLink>
                : null
              }
            </div>

            {this.state.popup ?
              <div className='popup-box'>
                <div className='box'>
                  <div className='row'>
                    <div className='col-md-12 mt-3 filterul'>
                      <div className='col'>
                        <div className='form-group'>
                          <label>Roles</label>
                          <Select value={this.state.roles} options={this.Roles} isSearchable={true} isClearable={true}
                            isMulti={true} onChange={roles => this.setState({ ...this.state, roles })} />
                        </div>
                      </div>
                      <div className='col'>
                        <div className='form-group'>
                          <label>Users</label>
                          <Select value={this.state.users} options={this.Users} isSearchable={true} isClearable={true}
                            isMulti={true} onChange={users => this.setState({ ...this.state, users })} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button onClick={this.onCancel}>Cancel</Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={this.onSubmit}>Submit</Button>
                </div>
              </div>
              : null
            }

            <ApiUiController inApiCall={this.props.inApiCall}>
              <div className="col-md-12">
                <div className="content-box">
                  <nav className="project-tab">
                    <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                      {this.report ? this.report.map((module, i) => {

                        return <span id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                          className={`alert alert-dark nav-item nav-link ${this.state.active === module ? 'active' : ''}`}
                          aria-selected="true" key={`tab_${i}`} onClick={() => this.onTabClick(module)}>
                          {module}
                        </span>;
                      }) : null
                      }
                    </div>
                  </nav>
                </div>
              </div>

              <div className="col-md-12">
                {this.state.active === "Dynamic Reports" ?
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.report.map((report, i) =>
                        <tr key={`report_${i}`}>
                          <td>{i + 1}</td>
                          <td>{report.name}</td>
                          <td>
                            <NavLink to={`${this.path}/${report.id}`} className='buttons update buttons-sm'>
                              <FaList /> View
                            </NavLink>
                            {this.Permission ?
                              <span className='buttons call buttons-sm' onClick={() => this.onPermit(report)}>
                                <FaCog /> Allow Permission
                              </span>
                              : null
                            }
                            {this.Edit ?
                              <span className='buttons sales buttons-sm' onClick={() => this.onEdit(report)}>
                                <FaPencilAlt /> Edit
                              </span>
                              : null
                            }
                            {this.Add ?
                              <span className='buttons call buttons-sm' onClick={() => this.onCopy(report.id)}>
                                <FaClone /> Copy
                              </span>
                              : null
                            }
                            {report.status !== Const.AlwaysActive && this.Delete
                              ? <span onClick={() => this.confirmDelete(report)} className="buttons delete buttons-sm">
                                <FaTrash /> Delete
                              </span>
                              : null
                            }
                          </td>
                        </tr>)}   </tbody>
                  </Table> :
                  this.fixedReports.map((report, i) =>
                    <>
                      <div key={`report_${i}`} className="col-md-12">
                        <div className="formhead"><h2>{report.title}</h2>
                          {
                            <Table striped bordered hover>
                              <thead>
                                <tr>
                                  <th>No</th>
                                  <th>Name</th>
                                  <th style={{ width: '30%' }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {report.reports.map((obj, j) =>
                                  <tr key={`report_${j}`}>
                                    <td width={10}>{j + 1}</td>
                                    <td>{obj.name}</td>
                                    <td>
                                      <NavLink to={`${this.path}${obj.link}`} className='buttons update buttons-sm'>
                                        <FaList /> View
                                      </NavLink>
                                    </td>
                                  </tr>)}
                              </tbody>
                            </Table>
                          }

                        </div >
                      </div>
                    </>
                  )
                }
              </div >
            </ApiUiController>
          </div>
        </div >
      </div >
    );
  }
}
export default withRouter(ReportList2);
